import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';

import './hourItem.scss';

export function FacilityHourItem({
	dayName: dayNameProp,
	dayNameFormat = 'provided',
	openTime,
}) {
	const dayName =
		dayNameFormat === 'abbreviated'
			? dayNameProp.substr(0, 3)
			: dayNameProp;
	return (
		<li className="hour-item">
			<Text
				color="gray"
				className={`day-name ${dayNameFormat}`}
			>
				{dayName}
			</Text>
			<Text
				color="gray"
				className="open-time"
			>
				{openTime}
			</Text>
		</li>
	);
}

FacilityHourItem.propTypes = {
	/** The name of the day */
	dayName: PropTypes.string,
	/** How the day name should be formatted */
	dayNameFormat: PropTypes.oneOf(['provided', 'abbreviated']),
	/** A string representing the open time. e.g. "10:00AM - 5:00PM" */
	openTime: PropTypes.string.isRequired
};

export default FacilityHourItem;
